import { boolean, object, string } from 'yup'

const SolusSchema = object().shape({
  title: string()
    .required('Title is required')
    .min(1, 'Title must be at least 2 characters')
    .max(10, 'Title must be at most 10 characters')
    .trim(),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  tel: string()
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  preference: string().trim().required('Please select an option').trim(),
  is_lexus: boolean(),
  campaign_response_code: string().uppercase().trim(),
  campaign_code: string().uppercase().trim(),
  consent: object({
    user: boolean(),
  }),
})

export default SolusSchema
